const REVIEWS_BY_ENUM = require('./../enums/review-factory-enum');

function ReviewFactory(ReviewsByProduct, ReviewsByShopper, ReviewsByStore) {
	this.reviewsByProduct = ReviewsByProduct;
	this.reviewsByShopper = ReviewsByShopper;
	this.reviewsByStore = ReviewsByStore;
}

ReviewFactory.prototype.get = function (type, request, options, bazaarvoiceCallEnabled) {
	switch (type) {
		case REVIEWS_BY_ENUM.BY_PRODUCT:
			return this.reviewsByProduct.get(request, options, bazaarvoiceCallEnabled);
		case REVIEWS_BY_ENUM.BY_SHOPPER:
		case REVIEWS_BY_ENUM.BY_PROFILE:
			return this.reviewsByShopper.get(request, options, bazaarvoiceCallEnabled);
		case REVIEWS_BY_ENUM.BY_STORE:
			return this.reviewsByStore.get(request, options);
		default:
			throw new Error('Review type not found');
	}
};

module.exports = ReviewFactory;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/factory/review-factory.js
 **/